/* eslint-disable */

import React, { useState } from 'react'
import { injectIntl } from 'react-intl'
import CloseIcon from '@uniiverse/library/assets/icons/x.svg'

import isMobile from 'lib/is-mobile.js'
import {
  googleTagManagerEvent
} from 'src/lib/digital-data'

import {
  FacebookShareButton,
  TwitterShareButton,
  EmailShareButton,
} from 'react-share'

import IconFacebook from 'src/assets/Icons/facebook.svg'
import IconXwitter from 'src/assets/Icons/xwitter.svg'
import IconEnvelope from 'src/assets/Icons/envelope.svg'
import IconDocuments from 'src/assets/Icons/documents.svg'
import IconCheck from 'src/assets/Icons/check.svg'
import IconEllipsis from 'src/assets/Icons/ellipsis.svg'
import IconShare from 'src/assets/Icons/share.svg'

import { ModalComponent as Modal } from 'src/elements/Modal/Modal'
import { Card } from 'src/elements/Card'

import style from './index.css'

import locale from './locale'

const ShareComponent = (props) => {
  const {
    intl: { formatMessage },
    url = window.location.href,
    text: overrideText,
  } = props

  // use default text if none provided as prop
  const text = overrideText || formatMessage(locale.shareEventText);

  const [open, setOpen] = useState(false)
  const [copied, setCopied] = useState(false)

  const clickShare = () => {
    googleTagManagerEvent({ event: 'share' })
    if ( isMobile ) {
      navigator.share && navigator.share({ url, text })
    } else {
      setOpen(true)
    }
  }

  const copyText = (text)=> {
    const on = setCopied.bind(this, true)
    const off = setCopied.bind(this, false)
    navigator.clipboard && navigator.clipboard.writeText(text).then( ()=> {
      on()
      setTimeout(off, 1000)
    })
  }

  return (
    <>
      <button className={`${style.shareButton} ${style.button}`} onClick={clickShare}>
        <IconShare />
        {formatMessage(locale.shareEvent)}
      </button>
      <Modal showModal={open} onClose={() => setOpen(false)}>
        <Card>
          <div className={style.header}>
            {formatMessage(locale.shareEvent)}
            <CloseIcon className={style.closeIcon} onClick={() => setOpen(false)} />
          </div>
          <div className={style.buttons}>

            <FacebookShareButton
              url={`${url}?ref=share-widget-facebook`}
              className={style.button}
            >
              <div className={style.button}>
                <IconFacebook />
                Facebook
              </div>
            </FacebookShareButton>

            <TwitterShareButton
              title={text}
              url={`${url}?ref=share-widget-twitter`}
              className={style.button}
            >
              <div className={style.button}>
               <IconXwitter />
                Twitter
              </div>
            </TwitterShareButton>

            <EmailShareButton
              subject={text}
              url={`${url}?ref=share-widget-email`}
              className={style.button}
            >
              <div className={style.button}>
                <IconEnvelope />
                Email
              </div>
            </EmailShareButton>

            <div className={style.button} onClick={()=> copyText(`${url}?ref=share-widget-buffer`)}>
              {copied && <>
                <IconCheck />
                {formatMessage(locale.linkCopied)}
              </>}
              {copied || <>
                <IconDocuments />
                {formatMessage(locale.copyLink)}
              </>}
            </div>

            {navigator.share && navigator.canShare({ url, text }) &&
              <div
                className={style.button}
                onClick={() => navigator.share({ url: `${url}?ref=share-sheet`, text })}
              >
                <IconEllipsis />
                {formatMessage(locale.more)}
              </div>
            }
          </div>
        </Card>
      </Modal>
    </>
  )
}

export const Share = injectIntl(ShareComponent)
